(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ledstar-advisor"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ledstar-advisor'))customElements.define('ledstar-advisor',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const fileInput=this.querySelector('[data-photo]'),preview=this.querySelector('[data-photo-preview]'),remove=this.querySelector('[data-photo-remove]'),photoStatus=this.querySelector('[data-photo-status]');
this.photo=null;this.photoSequence=0;this.photoBusy=false;
const clearPhoto=()=>{this.photoSequence++;this.photo=null;this.photoBusy=false;fileInput.value='';fileInput.setCustomValidity('');preview.removeAttribute('src');preview.hidden=true;remove.hidden=true;photoStatus.textContent='';};
remove.addEventListener('click',clearPhoto);
fileInput.addEventListener('change',async()=>{
const file=fileInput.files[0],sequence=++this.photoSequence;
this.photo=null;preview.removeAttribute('src');preview.hidden=true;remove.hidden=!file;fileInput.setCustomValidity('');
if(!file){this.photoBusy=false;photoStatus.textContent='';return;}
this.photoBusy=true;photoStatus.textContent=this.dataset.photoLoading;
let bitmap;
try{
if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>10*1024*1024)throw Error('file');
bitmap=await createImageBitmap(file);
if(bitmap.width*bitmap.height>50000000)throw Error('size');
const scale=Math.min(1,1280/Math.max(bitmap.width,bitmap.height)),canvas=document.createElement('canvas');
canvas.width=Math.max(1,Math.round(bitmap.width*scale));canvas.height=Math.max(1,Math.round(bitmap.height*scale));
const context=canvas.getContext('2d');context.fillStyle='#ffffff';context.fillRect(0,0,canvas.width,canvas.height);context.drawImage(bitmap,0,0,canvas.width,canvas.height);
let photo=canvas.toDataURL('image/jpeg',0.8);if(photo.length>1400000)photo=canvas.toDataURL('image/jpeg',0.55);
if(photo.length>1400000)throw Error('size');
if(sequence!==this.photoSequence)return;
this.photo=photo;preview.src=photo;preview.hidden=false;photoStatus.textContent=this.dataset.photoReady;
}catch{if(sequence===this.photoSequence){fileInput.setCustomValidity(this.dataset.photoError);photoStatus.textContent=this.dataset.photoError;}}
finally{bitmap?.close();if(sequence===this.photoSequence)this.photoBusy=false;}
});
this.querySelector('form').addEventListener('submit',async e=>{
e.preventDefault();
const result=this.querySelector('.lsa-results'),button=this.querySelector('button[type="submit"]');
result.replaceChildren();
if(this.photoBusy){result.textContent=this.dataset.photoLoading;return;}
if(!fileInput.reportValidity())return;
if(!this.dataset.endpoint){result.textContent=this.dataset.pending;result.focus();return;}
button.disabled=true;fileInput.disabled=true;remove.disabled=true;result.textContent=this.dataset.loading;
const fail=(message,code)=>{const error=new Error(message+' ['+code+']');error.advisorSafe=true;throw error;};
try{
const endpoint=new URL(this.dataset.endpoint);
if(endpoint.origin!=='https://ledstar-ai-advisor.8724yamagata8724.workers.dev'||endpoint.pathname!=='/recommend')throw Error(this.dataset.notReady);
let ready;
try{const health=await fetch(new URL('/health',endpoint),{signal:AbortSignal.timeout(10000)});ready=health.ok?await health.json():null;}catch{throw Error(this.dataset.notReady);}
if(ready?.version!=='ledstar-advisor-v1'||ready.ready!==true)throw Error(this.dataset.notReady);
if(this.photo&&ready.capabilities?.photo!==true)fail(this.dataset.photoUpdate,'PHOTO_UPDATE');
if(ready.capabilities?.public!==true)throw Error(this.dataset.notReady);
const response=await fetch(endpoint.href,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({answers:Object.fromEntries(new FormData(e.target)),photo:this.photo}),signal:AbortSignal.timeout(65000)});
if(response.status===401)throw Error(this.dataset.passwordError);
let data;
try{data=await response.json();}catch{fail(this.dataset.invalidResponse,'HTTP-'+response.status);}
if(!response.ok){
const messages=new Map([
['AIの利用上限に達したか、混み合っています。時間をおいてお試しください。',this.dataset.aiLimit],
['AIに接続できませんでした。接続設定をご確認ください。',this.dataset.aiConnection],
['商品情報またはAI回答を確認できませんでした。時間をおいてお試しください。',this.dataset.catalogOrAi]
]);
const statuses={400:this.dataset.inputError,403:this.dataset.originError,413:this.dataset.inputError,415:this.dataset.inputError,429:this.dataset.aiLimit,503:this.dataset.configError};
const diagnostic=typeof data?.code==='string'&&/^(CART|PRODUCT|AI|MODEL|INTERNAL)_[A-Z0-9_]{1,64}$/.test(data.code)?' / '+data.code:'';
fail(messages.get(data?.message)||statuses[response.status]||this.dataset.error,'HTTP-'+response.status+diagnostic);
}
if(data.version!=='ledstar-advisor-v1'||typeof data.summary!=='string'||!Array.isArray(data.recommendations))fail(this.dataset.invalidResponse,'RESPONSE');
result.replaceChildren();
const heading=document.createElement('h3'),summary=document.createElement('p');
heading.textContent=this.dataset.result;summary.textContent=data.summary;result.append(heading,summary);
for(const [index,item] of data.recommendations.slice(0,2).entries()){
if(typeof item.title!=='string'||typeof item.reason!=='string'||typeof item.url!=='string'||typeof item.price!=='number'||item.currency!=='JPY')continue;
const url=new URL(item.url,location.origin);
if(url.origin!==location.origin||!url.pathname.startsWith('/products/'))continue;
const card=document.createElement('article'),title=document.createElement('h3'),price=document.createElement('p'),reason=document.createElement('p'),link=document.createElement('a');
const badge=document.createElement('p');badge.className='lsa-badge';badge.textContent=index===0?this.dataset.firstPick:this.dataset.otherPick;card.append(badge);
title.textContent=item.title;price.textContent=new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY'}).format(item.price);
reason.textContent=item.reason;link.href=url.href;link.textContent=this.dataset.details;card.append(title,price,reason,link);result.append(card);
}
if(typeof data.photoInsights==='string'&&data.photoInsights){const box=document.createElement('article'),h=document.createElement('h3'),p=document.createElement('p'),limit=document.createElement('p');h.textContent=this.dataset.photoHeading;p.textContent=data.photoInsights;limit.textContent=this.dataset.photoLimit;box.append(h,p,limit);result.append(box);}
if(typeof data.notice==='string'){const note=document.createElement('p');note.className='lsa-note';note.textContent=data.notice;result.append(note);}
}catch(error){
if(error.advisorSafe||[this.dataset.notReady,this.dataset.passwordError].includes(error.message))result.textContent=error.message;
else if(error.name==='TimeoutError'||error.name==='AbortError')result.textContent=this.dataset.timeoutError+' [TIMEOUT]';
else if(error instanceof TypeError)result.textContent=this.dataset.networkError+' [NETWORK]';
else result.textContent=this.dataset.error+' [CLIENT]';
}
finally{button.disabled=false;fileInput.disabled=false;remove.disabled=false;result.focus();}
});
}
});

  } catch(e) { console.error(e); }
})();
})();
